export const WelComeLogo = (props) => {
  return (
    <svg width="78" height="72" viewBox="0 0 78 72" fill="none" {...props}>
      <path d="M3 31.5H12V60H3V31.5Z" fill="url(#paint0_linear_26_1041)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.6406 43.2227C74.2344 42.1836 72.3594 41.8789 70.4883 42.3984L47.5547 48.7383C47.8359 48.043 48 47.2852 48 46.4883C48 43.1836 45.3086 40.5 42 40.5H27.9336C27.8402 40.36 27.7334 40.1938 27.6137 40.0075C26.4514 38.1989 24.0741 34.5 21 34.5H15V33C15 30.5195 12.9805 28.5 10.5 28.5H4.5C2.01953 28.5 0 30.5195 0 33V58.5C0 60.9805 2.01953 63 4.5 63H10.5C12.9805 63 15 60.9844 15 58.5V57.3711L33.207 69.6758C35.4961 71.2227 38.1562 72 40.8203 72C43.2852 72 45.75 71.3359 47.9336 70.0039L75.1953 53.3516C76.9258 52.2969 78 50.3789 78 48.3516V47.8828C78 46.0352 77.1406 44.3398 75.6406 43.2227ZM12 58.5C12 59.3281 11.3281 60 10.5 60H9V54H6V60H4.5C3.67188 60 3 59.3281 3 58.5V33C3 32.1719 3.67188 31.5 4.5 31.5H10.5C11.3281 31.5 12 32.1719 12 33V58.5ZM73.6289 50.793C74.4766 50.2773 75 49.3438 75 48.3516V47.8828C75 46.9961 74.582 46.1758 73.8516 45.6328C73.207 45.1484 72.2461 45.0234 71.2852 45.2891L45 52.5H27V49.5H42C43.6562 49.5 45 48.1484 45 46.4844C45 44.8398 43.6562 43.5 42 43.5H26.0312L25.6328 42.6133C24.7031 40.5508 22.5898 37.5 21 37.5H15V53.7539L34.8906 67.1914C38.3164 69.5117 42.8242 69.6094 46.3711 67.4414L73.6289 50.793Z"
        fill="url(#paint1_linear_26_1041)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 10.5C69 23.1602 53.4453 33 49.5 33C45.5547 33 30 23.1602 30 10.5C30 4.71094 34.7109 0 40.5 0C44.3164 0 47.6602 2.04297 49.5 5.09375C51.3398 2.04297 54.6836 0 58.5 0C64.2891 0 69 4.71094 69 10.5ZM48 10.5C48 6 44.6367 3 40.5 3C36.3633 3 33 6.36328 33 10.5C33 21.8438 47.5195 30 49.5 30C51.4805 30 66 21.8438 66 10.5C66 6.36328 62.6367 3 58.5 3C54.3633 3 51 6 51 10.5H48Z"
        fill="url(#paint2_linear_26_1041)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_26_1041"
          x1="2.52562"
          y1="30.4995"
          x2="2.52562"
          y2="62.0041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CDDDF" />
          <stop offset="1" stopColor="#8CC2DF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_26_1041"
          x1="-28.9205"
          y1="-1.49999"
          x2="-28.9205"
          y2="74.2576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_26_1041"
          x1="4.73422"
          y1="-1.49999"
          x2="4.73422"
          y2="74.2576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const HearLogo = (props) => {
  return (
    <svg width="78" height="58" viewBox="0 0 78 58" fill="none" {...props}>
      <path
        d="M18 6.5C11.3711 6.5 6 11.8711 6 18.5H18V6.5Z"
        fill="url(#paint0_linear_35_4153)"
      />
      <path
        d="M67.7734 20C67.6836 19.9961 67.5938 19.9883 67.5 19.9883C67.4492 19.9883 67.4023 20 67.3516 20H67.7734Z"
        fill="#74B8F2"
      />
      <path
        d="M58.5 27.5H58.3984C57.7734 23.2539 54.0312 19.9883 49.5 19.9883C44.5273 19.9883 40.5 23.9102 40.5 28.7539C40.5 39.0117 50.4844 45.7969 55.582 48.5938C56.4922 49.0938 57.4961 49.3438 58.5 49.3438V27.5Z"
        fill="url(#paint1_linear_35_4153)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.9961 18.6016C68.9961 18.5864 68.997 18.5703 68.998 18.5538C68.999 18.5362 69 18.5181 69 18.5C69 8.57422 60.9258 0.5 51 0.5C43.6289 0.5 37.2812 4.95312 34.5 11.3086C31.7188 4.95312 25.3711 0.5 18 0.5C8.07422 0.5 0 8.57422 0 18.5C0 39.3477 29.4727 57.5 34.5 57.5C37.3359 57.5 44.7344 53.1836 51.2695 47.7656C51.3371 47.8182 51.4031 47.8659 51.4695 47.914C51.5068 47.941 51.5441 47.968 51.582 47.9961C51.5859 47.9766 51.5898 47.957 51.5898 47.9336C52.75 48.6953 53.8633 49.3594 54.8594 49.9062C56 50.5312 57.25 50.8438 58.5 50.8438C59.7461 50.8438 61 50.5312 62.1367 49.9062C68.0625 46.6602 78 39.5938 78 28.7539C78 23.5898 74.0781 19.3164 68.9961 18.6016ZM34.5 54.5C31.1562 54.5 3 37.4492 3 18.5C3 10.2305 9.73047 3.5 18 3.5C26.2695 3.5 33 10.2305 33 18.5H36C36 10.2305 42.7305 3.5 51 3.5C59.2695 3.5 66 10.2305 66 18.5C66 18.5152 65.9991 18.5312 65.9981 18.5478C65.9971 18.5654 65.9961 18.5835 65.9961 18.6016C62.8516 19.0508 60.1016 20.8906 58.5 23.4922C56.6484 20.4805 53.2617 18.4883 49.5 18.4883C43.7109 18.4883 39 23.0898 39 28.7539C39 36.3242 43.8477 42.0469 48.7891 45.9219C41.9648 51.4766 35.8516 54.5 34.5 54.5ZM56.3008 47.2773C57.6797 48.0352 59.3203 48.0352 60.6953 47.2773C64.9961 44.918 75 38.3945 75 28.7539C75 24.7461 71.6328 21.4883 67.5 21.4883C63.7969 21.4883 60.6094 24.168 60.0859 27.7188L59.8984 29H57.1016L56.9141 27.7188C56.3906 24.1641 53.2031 21.4883 49.5 21.4883C45.3633 21.4883 42 24.7461 42 28.7539C42 38.3945 52.0039 44.918 56.3008 47.2773Z"
        fill="url(#paint2_linear_35_4153)"
      />
      <path
        d="M67.5 24.5C65.0195 24.5 63 26.5195 63 29H66C66 28.1719 66.6719 27.5 67.5 27.5C68.3281 27.5 69 28.1719 69 29H72C72 26.5195 69.9805 24.5 67.5 24.5Z"
        fill="url(#paint3_linear_35_4153)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_4153"
          x1="4.68751"
          y1="5.75002"
          x2="4.68751"
          y2="20.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CDDDF" />
          <stop offset="1" stopColor="#8CC2DF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_4153"
          x1="42.7485"
          y1="19.712"
          x2="42.7485"
          y2="41.7336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CDDDF" />
          <stop offset="1" stopColor="#8CC2DF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_35_4153"
          x1="1.69856"
          y1="2.22352"
          x2="1.69856"
          y2="56.7411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_35_4153"
          x1="12.9825"
          y1="2.22352"
          x2="12.9825"
          y2="56.7411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LadyLogo = (props) => {
  return (
    <svg width="54" height="87" viewBox="0 0 54 87" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 28C24 27.4477 23.4639 27 22.8026 27H18.1974C17.5361 27 17 27.4477 17 28C17 28.5522 17.5361 29 18.1974 29H22.8026C23.4639 29 24 28.5522 24 28Z"
        fill="url(#paint0_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1974 29H36.8026C37.4639 29 38 28.5522 38 28C38 27.4477 37.4639 27 36.8026 27H32.1974C31.5361 27 31 27.4477 31 28C31 28.5522 31.5361 29 32.1974 29Z"
        fill="url(#paint1_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 36C27.5523 36 28 35.4743 28 34.8259V33.1741C28 32.5257 27.5523 32 27 32C26.4477 32 26 32.5257 26 33.1741V34.8259C26 35.4743 26.4477 36 27 36Z"
        fill="url(#paint2_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.954 39.2367C28.2564 41.1097 25.7435 41.1097 23.0458 39.2367C22.4807 38.8447 21.6794 38.9505 21.2557 39.4736C20.8321 39.9964 20.9466 40.7384 21.5114 41.1306C23.3069 42.3769 25.1533 43 26.9999 43C28.8465 43 30.693 42.3769 32.4884 41.1306C33.0534 40.7384 33.1679 39.9964 32.7442 39.4736C32.3204 38.9506 31.5194 38.8447 30.954 39.2367Z"
        fill="url(#paint3_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23741 60C6.92065 60 7.47482 59.4501 7.47482 58.7717V21.838C7.47482 11.1511 16.2336 2.4566 27 2.4566C32.2167 2.4566 37.1195 4.4729 40.8059 8.13437C44.4941 11.7928 46.5252 16.6597 46.5252 21.838V58.7717C46.5252 59.4501 47.0792 60 47.7626 60C48.4458 60 49 59.4501 49 58.7717V21.838C49 16.0032 46.7112 10.5194 42.5558 6.39736C38.4026 2.27198 32.8781 0 27 0C14.869 0 5 9.79654 5 21.838V58.7717C5 59.4501 5.55398 60 6.23741 60Z"
        fill="url(#paint4_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4689 49.5755C28.0967 49.8504 27.5612 50.0079 27.0001 50.0079C26.4388 50.0079 25.9033 49.8504 25.5313 49.5755L19.6629 45.241C15.3908 42.0855 13.0381 37.9249 13.0381 33.5258V22.7473C14.888 22.5639 18.7565 22.1303 22.709 21.3788C28.3725 20.3022 31.3788 19.098 32.9705 17.9593C33.4862 19.2863 34.376 20.8379 35.892 21.8999C37.3126 22.8949 39.0132 23.2924 40.9619 23.0877V33.5258C40.9619 37.925 38.6092 42.0857 34.3371 45.241L28.4689 49.5755ZM39.654 57.6333L38.3692 57.2677C35.3445 56.4102 33.3123 54.0953 33.3123 51.5075V49.0338L35.79 47.2038C40.6299 43.629 43.4056 38.6436 43.4056 33.5258V21.6346C43.4056 21.2598 43.2332 20.9058 42.9381 20.6745C42.643 20.443 42.2574 20.3602 41.8933 20.4492C40.0218 20.9068 38.4784 20.725 37.3052 19.9084C35.1215 18.388 34.7262 15.1189 34.7228 15.0896C34.6559 14.4696 34.1318 14 33.508 14C33.507 14 33.5061 14 33.5053 14C32.8801 14.0013 32.357 14.4737 32.2925 15.0949C32.2841 15.1771 31.9724 17.1309 22.2688 18.9778C17.0305 19.9747 11.7687 20.4141 11.7159 20.4182C11.0822 20.4704 10.5944 20.9994 10.5944 21.6346V33.5258C10.5944 38.6435 13.3701 43.629 18.21 47.2038L20.6879 49.034V51.5075C20.6879 54.0953 18.6557 56.4102 15.6299 57.2681L14.346 57.6333C6.33079 59.904 0 61.6976 0 69.7414V72.7795C0 73.4536 0.547006 74 1.22183 74C1.89666 74 2.44367 73.4536 2.44367 72.7795V69.7414C2.44367 63.8059 6.52403 62.3865 15.0128 59.9818L16.2981 59.616C20.3856 58.4572 23.1316 55.1987 23.1316 51.5075V50.8388L24.0784 51.5383C24.8737 52.1256 25.9113 52.4489 27.0001 52.4489C28.0888 52.4489 29.1265 52.1256 29.9216 51.5383L30.8686 50.8388V51.5075C30.8686 55.1987 33.6147 58.4571 37.7005 59.6156L38.9874 59.9818C47.476 62.3865 51.5563 63.8059 51.5563 69.7414V72.7795C51.5563 73.4536 52.1033 74 52.7782 74C53.453 74 54 73.4536 54 72.7795V69.7414C54 61.6976 47.6692 59.904 39.654 57.6333Z"
        fill="url(#paint5_linear_35_4231)"
      />
      <path
        d="M20 68C17.7904 68 16 69.7904 16 72H20V68Z"
        fill="url(#paint6_linear_35_4231)"
      />
      <path
        d="M37.7109 72.5059C37.6211 72.502 37.5312 72.4941 37.4375 72.4941C37.3867 72.4941 37.3398 72.5059 37.2891 72.5059H37.7109Z"
        fill="#74B8F2"
      />
      <path
        d="M34 75.5589H33.9661C33.7578 74.1124 32.5104 73 31 73C29.3424 73 28 74.336 28 75.986C28 79.4804 31.3281 81.7917 33.0273 82.7445C33.3307 82.9148 33.6654 83 34 83V75.5589Z"
        fill="url(#paint7_linear_35_4231)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1319 65C34.6377 65 37.5251 67.8329 37.8672 71.4461L37.8819 71.6245L37.8869 71.7165L37.9546 71.735C39.6328 72.228 40.8658 73.7702 40.9897 75.6052L40.9976 75.7631L41 75.9102C41 79.4473 38.6471 82.176 35.2458 84.1516C34.7737 84.4269 34.2464 84.5698 33.7143 84.5698C33.1816 84.5698 32.6559 84.4273 32.1817 84.1518L32.0687 84.0853L31.7354 83.8819L31.7171 83.9827L31.2417 83.6096L31.071 83.754C28.9733 85.5114 26.7751 86.8483 25.6356 86.9879L25.5378 86.9971L25.4505 87C24.2501 87 21.0506 85.0178 18.4772 82.5799C15.0876 79.369 13 75.7595 13 72.1664C13 68.2166 16.0335 65 19.7692 65C21.9964 65 24.0265 66.1545 25.2744 67.9994L25.3824 68.1639L25.4503 68.2732L25.5187 68.1639C26.6863 66.3317 28.6092 65.1388 30.75 65.0113L30.9513 65.0025L31.1319 65ZM31.1319 67.2845C28.6494 67.2845 26.6151 69.3928 26.5406 72.0173L26.5385 72.1664V72.761H24.3626V72.1664C24.3626 69.4731 22.2986 67.2845 19.7692 67.2845C17.2399 67.2845 15.1758 69.4731 15.1758 72.1664C15.1758 75.0287 16.9872 78.0706 19.9794 80.8921C21.1338 81.9806 22.4022 82.9687 23.5715 83.7241C24.5004 84.3242 25.2997 84.7155 25.4505 84.7155C25.809 84.7155 27.4637 83.7497 29.1394 82.4333L29.4714 82.1677L29.3023 82.0092C27.5522 80.3359 26.496 78.3787 26.4317 76.1288L26.4286 75.9102C26.4286 73.5138 28.3065 71.5676 30.6154 71.5676C31.7728 71.5676 32.8618 72.0712 33.6405 72.9169L33.7143 72.9997L33.8177 72.8862C34.3047 72.3686 34.911 71.9806 35.5797 71.7645L35.7063 71.7255C35.4987 69.2854 33.5974 67.3613 31.2719 67.2867L31.1319 67.2845ZM34.8436 75.5103C35.0266 74.5611 35.8564 73.8521 36.8132 73.8521C37.9228 73.8521 38.8242 74.7776 38.8242 75.9102C38.8242 78.4552 36.8589 80.6024 34.1913 82.1541C33.8906 82.3298 33.5375 82.3298 33.2363 82.1543C30.5682 80.6009 28.6044 78.455 28.6044 75.9102C28.6044 74.7771 29.5049 73.8521 30.6154 73.8521C31.6082 73.8521 32.4633 74.6138 32.6027 75.6173L32.7375 76.5946H34.691L34.826 75.6167L34.8436 75.5103Z"
        fill="url(#paint8_linear_35_4231)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_4231"
          x1="13.5"
          y1="28"
          x2="14.5566"
          y2="31.6981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_4231"
          x1="27.5"
          y1="28"
          x2="28.5566"
          y2="31.6981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_35_4231"
          x1="25"
          y1="34"
          x2="28.2"
          y2="35.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_35_4231"
          x1="15"
          y1="41"
          x2="17.4"
          y2="48.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_35_4231"
          x1="-17"
          y1="30"
          x2="40.2254"
          y2="71.9653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_35_4231"
          x1="-27"
          y1="44"
          x2="32.6685"
          y2="97.7017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_35_4231"
          x1="15.5625"
          y1="67.75"
          x2="15.5625"
          y2="72.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CDDDF" />
          <stop offset="1" stopColor="#8CC2DF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_35_4231"
          x1="28.7495"
          y1="72.9059"
          x2="28.7495"
          y2="80.4076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CDDDF" />
          <stop offset="1" stopColor="#8CC2DF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_35_4231"
          x1="-1"
          y1="76"
          x2="20.3754"
          y2="103.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PlusIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M15 7H9V1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7Z"
        fill="white"
      />
    </svg>
  );
};

export const MinusIcon = (props) => {
  return (
    <svg width="16" height="2" viewBox="0 0 16 2" fill="none" {...props}>
      <path
        d="M15 2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2Z"
        fill="white"
      />
    </svg>
  );
};

export const HeadSet = (props) => {
  return (
    <svg width="21" height="31" viewBox="0 0 21 31" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 15.5C11 15.2239 10.7761 15 10.5 15C10.2239 15 10 15.2239 10 15.5C10 15.7762 10.2239 16 10.5 16C10.7761 16 11 15.7762 11 15.5Z"
        fill="url(#paint0_linear_35_4280)"
      />
      <path
        d="M15.1635 0.757668C16.4051 0.651047 17.9319 1.70778 18.9583 2.96503C19.1155 3.15642 19.2133 3.39435 19.2415 3.64702L19.25 3.80015V5.0074C19.25 5.31445 19.1485 5.60922 18.9625 5.8377C18.0013 7.02145 16.5962 8.06178 15.4666 8.06178L15.2636 8.05585L15.0575 8.03732L15.0468 8.04972C14.8495 8.24487 14.6944 8.99813 14.6746 9.99437L14.6725 10.2115V12H14.422L14.4225 12.25H13.761V10.2115C13.761 8.89329 13.9323 7.8394 14.4203 7.35683C14.6267 7.15272 14.8884 7.05797 15.165 7.09092C15.2636 7.10249 15.3653 7.10838 15.4666 7.10838C16.2426 7.10838 17.4543 6.22187 18.2681 5.21976C18.2979 5.18322 18.3192 5.13748 18.3302 5.08674L18.3385 5.0074V3.80015C18.3385 3.71792 18.3122 3.64179 18.266 3.58555C17.4003 2.52526 16.0951 1.63509 15.2391 1.70787C14.3638 1.78447 13.5863 2.31565 13.1043 3.17423C13.033 3.30016 12.9708 3.4295 12.9137 3.57062C12.862 3.69946 12.8185 3.83186 12.7838 3.96588C12.7228 4.19204 12.6845 4.42357 12.6691 4.65784L12.6614 4.89294V12.25H11.75V4.89294C11.75 4.49117 11.8025 4.0928 11.9054 3.71149C11.9494 3.54099 12.0063 3.36829 12.0739 3.19981C12.1466 3.02008 12.2292 2.84827 12.3193 2.68938C12.9401 1.58351 14.0021 0.859427 15.1635 0.757668Z"
        fill="url(#paint1_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3946 2.52847C15.3337 2.49106 15.2615 2.49049 15.1967 2.52695C14.7897 2.75552 14.484 2.97394 14.2348 3.21416C13.9652 3.47399 13.7263 3.80291 13.5248 4.19155C13.463 4.31094 13.5254 4.4268 13.6155 4.47512C13.6453 4.49115 13.6791 4.5 13.7128 4.5C13.7759 4.5 13.839 4.46897 13.8772 4.39531C14.0644 4.03417 14.2743 3.74392 14.5191 3.50799C14.8046 3.23281 15.1392 3.03008 15.3988 2.88433C15.4618 2.84896 15.4987 2.78917 15.5 2.72015C15.5014 2.64387 15.4601 2.5687 15.3946 2.52847Z"
        fill="url(#paint2_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0003 4.13859C16.8226 4.13859 16.823 3.86157 17.0003 3.86157C17.178 3.86157 17.1777 4.13859 17.0003 4.13859Z"
        fill="url(#paint3_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10542 6.52843C5.16631 6.49105 5.23851 6.49048 5.30331 6.52699C5.71033 6.75551 6.01599 6.97393 6.26522 7.21415C6.53478 7.47397 6.7737 7.80289 6.97513 8.19152C7.03699 8.31091 6.97465 8.42676 6.88453 8.47508C6.85463 8.49111 6.82088 8.5 6.78714 8.5C6.72405 8.5 6.661 8.46893 6.62277 8.39527C6.43559 8.03414 6.22564 7.7439 5.9809 7.50797C5.69544 7.2328 5.36084 7.03007 5.10117 6.88432C5.03819 6.84896 5.00134 6.78917 5.00004 6.72015C4.99858 6.64383 5.03994 6.5687 5.10542 6.52843Z"
        fill="url(#paint4_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00036 6.86157C3.17774 6.86157 3.17802 7.13855 3.00036 7.13855C2.82294 7.13855 2.82266 6.86157 3.00036 6.86157Z"
        fill="url(#paint5_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02578 4.77772L5.83534 4.75711L5.63804 4.75024C4.44123 4.76127 3.02169 5.69851 2.04749 6.80524C1.85554 7.02326 1.75 7.305 1.75 7.59817V8.7195L1.75859 8.8641C1.78708 9.10271 1.88572 9.32737 2.04369 9.50803C3.00421 10.6065 4.40924 11.5722 5.53358 11.5722C5.66757 11.5722 5.80274 11.5648 5.9356 11.5501L5.94526 11.5501L5.98977 11.5924C6.1149 11.7393 6.23877 12.1204 6.2984 12.8286L6.33391 13.25H9.25V8.61326L9.24505 8.41374C9.15305 6.56204 7.78863 5.01705 6.02578 4.77772ZM2.66925 7.53194C2.67955 7.48918 2.6998 7.44977 2.72854 7.41713C3.59726 6.43042 4.90109 5.60461 5.76243 5.67506L5.92731 5.69366C7.28921 5.89113 8.33857 7.13989 8.33857 8.61326L8.338 12.329H7.159L7.12546 12.1216C7.015 11.5161 6.82388 11.0904 6.53911 10.8506C6.33918 10.6823 6.09367 10.6066 5.83692 10.6347C5.73671 10.6458 5.63465 10.6513 5.53358 10.6513C4.75189 10.6513 3.54027 9.82852 2.72673 8.8984C2.68491 8.85054 2.66143 8.7871 2.66143 8.7195V7.59817L2.66925 7.53194Z"
        fill="url(#paint6_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8254 12.8619H9.05161C8.81543 12.8619 8.6239 12.6689 8.6239 12.4309C8.6239 12.1929 8.81543 12 9.05161 12H11.8254C12.0616 12 12.2531 12.1929 12.2531 12.4309C12.2531 12.6689 12.0616 12.8619 11.8254 12.8619ZM15.9047 31H5.09521C2.28569 31 0 28.697 0 25.8664V13.5913C0 12.7139 0.708521 12 1.57937 12H6.92905C7.16527 12 7.35677 12.1929 7.35677 12.4309C7.35677 12.6689 7.16527 12.8619 6.92905 12.8619H1.57937C1.18019 12.8619 0.855465 13.1891 0.855465 13.5913V25.8664C0.855465 28.2218 2.75737 30.1381 5.09521 30.1381H15.9047C18.2426 30.1381 20.1446 28.2218 20.1446 25.8664V13.5913C20.1446 13.1891 19.8203 12.8619 19.4217 12.8619H13.9159C13.6797 12.8619 13.4882 12.6689 13.4882 12.4309C13.4882 12.1929 13.6797 12 13.9159 12H19.4217C20.292 12 21 12.7139 21 13.5913V25.8664C21 28.697 18.7143 31 15.9047 31Z"
        fill="url(#paint7_linear_35_4280)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13C14.8229 13.5727 14.1344 14 13.3145 14H7.68548C6.8656 14 6.17715 13.5727 6 13H15V12H6V13"
        fill="url(#paint8_linear_35_4280)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_4280"
          x1="9.5"
          y1="15.5"
          x2="10.5"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_4280"
          x1="8"
          y1="6.50014"
          x2="18.5238"
          y2="13.3636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_35_4280"
          x1="12.5"
          y1="3.5"
          x2="14.5"
          y2="5.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_35_4280"
          x1="16.8672"
          y1="3.86157"
          x2="16.8672"
          y2="4.13859"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#FFFFFE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_35_4280"
          x1="4"
          y1="7.5"
          x2="6"
          y2="9.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_35_4280"
          x1="2.86719"
          y1="6.86157"
          x2="2.86719"
          y2="7.13855"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#FFFFFE" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_35_4280"
          x1="-2"
          y1="9.0001"
          x2="6.4336"
          y2="16.4418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_35_4280"
          x1="-10.5"
          y1="21.5"
          x2="8.40524"
          y2="42.3953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_35_4280"
          x1="1.5"
          y1="13"
          x2="2.34706"
          y2="16.8118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BabyHead = (props) => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.604 18.0263C11.7617 18.0262 11.9131 17.9605 12.0246 17.8435C12.1361 17.7265 12.1988 17.5678 12.1988 17.4023C12.1988 16.0776 11.257 15 10.0994 15C8.94179 15 8 16.0776 8 17.4023C8 17.5678 8.06264 17.7265 8.17422 17.8435C8.28575 17.9605 8.43708 18.0263 8.59483 18.0263C8.75257 18.0263 8.90384 17.9605 9.01543 17.8435C9.12696 17.7265 9.18965 17.5678 9.18965 17.4023C9.18965 16.7658 9.59776 16.248 10.0994 16.248C10.6011 16.248 11.0092 16.7658 11.0092 17.4023C11.0092 17.5678 11.0719 17.7265 11.1834 17.8435C11.2949 17.9605 11.4462 18.0262 11.604 18.0263ZM19.9006 15C18.743 15 17.8012 16.0776 17.8012 17.4023C17.8012 17.5678 17.8639 17.7265 17.9754 17.8435C18.0869 17.9605 18.2383 18.0263 18.396 18.0263C18.5538 18.0263 18.7051 17.9605 18.8166 17.8435C18.9281 17.7265 18.9908 17.5678 18.9908 17.4023C18.9908 16.7658 19.3989 16.248 19.9006 16.248C20.4023 16.248 20.8103 16.7658 20.8103 17.4023C20.8103 17.5678 20.873 17.7265 20.9846 17.8435C21.0962 17.9605 21.2474 18.0263 21.4052 18.0263C21.563 18.0263 21.7142 17.9605 21.8258 17.8435C21.9374 17.7265 22 17.5678 22 17.4023C22 16.0776 21.0582 15 19.9006 15ZM18.2016 21.342C18.3132 21.225 18.4644 21.1593 18.6222 21.1593C18.78 21.1593 18.9312 21.225 19.0428 21.342C19.1544 21.459 19.217 21.6177 19.217 21.7833C19.217 22.6884 18.7481 23.5225 17.8965 24.132C17.1146 24.6917 16.0859 25 15 25C13.9141 25 12.8854 24.6917 12.1035 24.132C11.252 23.5225 10.783 22.6884 10.783 21.7833C10.783 21.6177 10.8456 21.459 10.9572 21.342C11.0688 21.225 11.2201 21.1593 11.3778 21.1593C11.5356 21.1593 11.6869 21.225 11.7984 21.342C11.91 21.459 11.9727 21.6177 11.9727 21.7833C11.9727 22.8504 13.359 23.752 15 23.752C16.641 23.752 18.0273 22.8504 18.0273 21.7833C18.0273 21.6177 18.09 21.459 18.2016 21.342Z"
        fill="url(#paint0_linear_35_4267)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9511 17.0691C29.7571 16.0939 29.2591 15.661 28.8756 15.4694C28.3748 15.2195 27.8451 15.2524 27.4563 15.3394C26.8048 9.14517 21.6959 4.27028 15.4272 4.03166C15.1424 3.86728 14.8888 3.65334 14.6783 3.3998C14.2907 2.91463 14.2421 2.42317 14.5253 1.8532C14.5612 1.78111 14.5826 1.70261 14.5883 1.62219C14.594 1.54177 14.584 1.461 14.5587 1.38451C14.5334 1.30801 14.4933 1.23728 14.4408 1.17637C14.3883 1.11545 14.3244 1.06554 14.2528 1.02949C14.181 0.993435 14.103 0.971944 14.0231 0.96625C13.9432 0.960555 13.8629 0.97076 13.7869 0.996288C13.7109 1.02182 13.6406 1.06217 13.5801 1.11503C13.5196 1.1679 13.4701 1.23224 13.4343 1.30438C13.035 2.10795 13.0268 2.92542 13.3988 3.66079C12.9737 3.50294 12.5846 3.2603 12.255 2.94741C11.6826 2.38787 11.3923 1.6027 11.3923 0.613655C11.3923 0.450907 11.3281 0.294819 11.2137 0.179736C11.0993 0.0646531 10.9442 0 10.7825 0C10.6207 0 10.4656 0.0646531 10.3512 0.179736C10.2369 0.294819 10.1726 0.450907 10.1726 0.613655C10.1726 1.94698 10.5873 3.02831 11.4051 3.82774C11.6087 4.02587 11.8317 4.20265 12.0708 4.35538C6.9415 5.56647 3.01162 9.94446 2.43759 15.3189C2.06872 15.249 1.60096 15.2411 1.15243 15.4623C0.577707 15.7457 0.206577 16.3092 0.0494081 17.1371C-0.161304 18.2469 0.304581 19.3452 1.3967 20.3131C1.9991 20.8469 2.73544 21.2736 3.26708 21.4779C3.89872 23.1308 4.83783 24.6474 6.03409 25.9463C8.44932 28.5604 11.6143 30 14.9458 30C18.2773 30 21.4422 28.5604 23.8575 25.9463C25.1078 24.5886 26.0767 22.994 26.7078 21.2553C27.4379 20.9896 28.7407 20.2694 29.475 19.1781C29.9273 18.5059 30.0919 17.7766 29.9511 17.0691ZM14.9458 5.2488C16.4975 5.24812 18.0327 5.56811 19.4564 6.18894C20.8801 6.80978 22.1619 7.71818 23.2224 8.85792C22.2444 8.62921 21.3013 8.66192 20.4024 8.95844C18.6511 9.53607 17.5242 10.9746 16.9582 11.8911C15.7189 10.1275 16.9056 8.09705 16.9616 8.0034C17.0279 7.89442 17.0587 7.76727 17.0497 7.63975C17.0407 7.51229 16.9924 7.39079 16.9114 7.2923C16.8305 7.19375 16.721 7.12311 16.5983 7.09022C16.4756 7.05733 16.3457 7.06383 16.2268 7.10882C14.8729 7.62091 13.938 8.45088 13.4482 9.57572C13.0038 10.5964 13.023 11.6564 13.1448 12.4408C12.5758 12.1374 12.1469 11.7253 11.8639 11.2088C11.3756 10.3174 11.4792 9.40948 11.5233 9.25011C11.5754 9.13137 11.5888 8.99912 11.5614 8.87228C11.5342 8.74544 11.4676 8.63056 11.3713 8.54422C11.2751 8.45782 11.1541 8.40437 11.0258 8.39154C10.8975 8.37866 10.7684 8.40713 10.6571 8.47273C8.94081 9.48459 8.78334 11.1804 8.7687 12.1039C6.91198 11.6341 6.37531 9.81492 6.26199 9.31804C7.32675 8.04335 8.65582 7.01855 10.156 6.3156C11.6561 5.6126 13.2909 5.2485 14.9458 5.2488ZM1.68596 16.566C1.42436 16.6973 1.30311 17.0743 1.24745 17.3674C1.05566 18.3776 1.93768 19.2714 2.74815 19.8208C2.49512 18.7936 2.36633 17.7394 2.36458 16.6811C2.36458 16.6578 2.36498 16.6346 2.36538 16.6115L2.36606 16.5639C2.16653 16.5056 1.88919 16.464 1.68596 16.566ZM22.9641 25.1106C20.7822 27.4721 17.9346 28.7727 14.9458 28.7727C11.957 28.7727 9.10931 27.4721 6.92741 25.1106C5.81039 23.8983 4.93935 22.4782 4.36319 20.9299C4.35334 20.8275 4.31803 20.7293 4.26053 20.6442C3.81701 19.3704 3.58844 18.0308 3.5843 16.6811C3.58166 14.4959 4.20513 12.3563 5.38004 10.5185C5.49152 10.7819 5.62286 11.0363 5.77295 11.2795C6.56485 12.5577 7.76872 13.2993 9.25452 13.4238C9.26769 13.4249 9.28099 13.4256 9.29422 13.4259C9.38052 13.4279 9.46626 13.4125 9.5464 13.3803C9.62653 13.3481 9.69941 13.2999 9.76052 13.2387C9.9866 13.0153 9.98672 12.7396 9.98684 12.358C9.98708 11.7382 10.0255 11.0702 10.3367 10.4852C10.399 10.8359 10.5034 11.1778 10.6476 11.5032C11.0369 12.3715 11.9122 13.5134 13.8715 14.022C13.9209 14.0349 13.9719 14.0414 14.023 14.0414C14.1227 14.0412 14.2209 14.0166 14.309 13.9695C14.397 13.9224 14.4724 13.8543 14.5282 13.7712C14.5842 13.6881 14.619 13.5924 14.6296 13.4926C14.6403 13.3928 14.6266 13.2919 14.5896 13.1987C14.5829 13.1819 13.9334 11.5087 14.5687 10.0606C14.7356 9.68286 14.9796 9.34467 15.2851 9.06816C15.2641 9.1707 15.2454 9.27643 15.2298 9.38475C15.0038 10.9514 15.5033 12.3399 16.6742 13.4003C16.746 13.4651 16.832 13.5119 16.9253 13.5368C17.0185 13.5617 17.1163 13.564 17.2106 13.5436C17.3049 13.5231 17.393 13.4804 17.4678 13.419C17.5425 13.3577 17.6018 13.2794 17.6407 13.1906C17.6511 13.1668 18.7066 10.8047 20.7896 10.1224C21.9562 9.73993 23.2571 9.95256 24.6572 10.7528C25.7389 12.5385 26.3098 14.5898 26.3073 16.6811C26.3073 19.7387 25.0888 22.8111 22.9641 25.1106ZM27.1815 19.6575C27.6413 19.3706 28.1411 18.9714 28.4649 18.49C28.7376 18.0849 28.8325 17.6989 28.7551 17.3101C28.6774 16.919 28.5354 16.6697 28.3334 16.5688C28.0787 16.4416 27.7185 16.5259 27.5259 16.5931C27.5259 16.5994 27.526 16.6057 27.5261 16.6119C27.5264 16.635 27.527 16.6579 27.527 16.6811C27.5252 17.6832 27.4093 18.6819 27.1815 19.6575Z"
        fill="url(#paint1_linear_35_4267)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_4267"
          x1="1"
          y1="20"
          x2="10.4595"
          y2="33.2432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_4267"
          x1="-15"
          y1="15"
          x2="15"
          y2="45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#3793C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WebLogo = (props) => {
  return (
    <svg width="140" height="88" viewBox="0 0 140 88" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.984 64.7219H134.393V69.2789H135.044V66.3938L136.684 69.5449L138.357 66.3984V69.2789H139.055V64.7219H138.509L136.731 68.0994L134.984 64.7219ZM133.549 65.3438V64.7219H129.695V65.3438H131.281V69.2638H131.964V65.3438H133.549V65.3438Z"
        fill="#2FC4CA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.707 74.5208L108.598 67.6771C107.744 67.0926 106.791 66.7893 105.714 66.7893C104.376 66.7893 103.271 67.3341 102.331 68.2744C101.386 69.2194 100.844 70.3278 100.844 71.6718C100.844 72.7346 101.13 73.6796 101.707 74.5208ZM9.71372 66.9736C10.0357 66.5023 10.4475 66.0974 10.9422 65.7591C11.8884 65.1139 12.9839 64.8584 14.1179 64.8584C15.4129 64.8584 16.5364 65.3391 17.4697 66.2328C18.5045 67.2221 18.9187 68.5183 18.9187 69.9323V78.6764H16.7709V69.9323C16.7709 69.0876 16.5165 68.3596 15.9215 67.7553C15.3557 67.1836 14.6919 66.8978 13.8869 66.8978C13.0457 66.8978 12.3492 67.2268 11.746 67.8078C11.1534 68.3794 10.8127 69.0491 10.8127 69.8774V78.6764H8.66372V69.8774C8.66372 69.0561 8.37788 68.3689 7.80855 67.7774C7.24622 67.1918 6.58005 66.8978 5.76688 66.8978C4.93388 66.8978 4.24905 67.2116 3.66222 67.7996C3.08238 68.3794 2.76038 69.0538 2.76038 69.8774V78.6764H0.612549V65.1583H2.76038V65.9633C2.97388 65.8081 3.19905 65.6669 3.43005 65.5386C4.21755 65.0988 5.06805 64.8584 5.97105 64.8584C6.93705 64.8584 7.80738 65.2119 8.57388 65.7906C9.02305 66.1313 9.40222 66.5268 9.71372 66.9736ZM51.7849 66.8359C52.1069 66.3646 52.5187 65.9598 53.0134 65.6226C53.9596 64.9774 55.0551 64.7219 56.1891 64.7219C57.4841 64.7219 58.6064 65.2026 59.5421 66.0963C60.5757 67.0856 60.9899 68.3818 60.9899 69.7946V78.5399H58.8421V69.7946C58.8421 68.9511 58.5877 68.2219 57.9916 67.6188C57.4269 67.0459 56.7631 66.7613 55.9581 66.7613C55.1157 66.7613 54.4204 67.0891 53.8172 67.6713C53.2246 68.2418 52.8839 68.9114 52.8839 69.7409V78.5399H50.7349V69.7409C50.7349 68.9184 50.4491 68.2313 49.8797 67.6398C49.3174 67.0553 48.6512 66.7613 47.8381 66.7613C47.0051 66.7613 46.3202 67.0751 45.7322 67.6631C45.1536 68.2418 44.8316 68.9161 44.8316 69.7409V78.5399H42.6837V65.0218H44.8316V65.8268C45.0451 65.6716 45.2702 65.5293 45.5001 65.4009C46.2887 64.9623 47.1392 64.7219 48.0422 64.7219C49.0082 64.7219 49.8786 65.0743 50.6439 65.6541C51.0942 65.9936 51.4734 66.3891 51.7849 66.8359ZM91.686 67.0611H85.953V65.0218H95.508L88.5174 76.5006H94.9282V78.5399H84.7222L91.686 67.0611ZM118.141 66.1896C119.2 65.1898 120.594 64.7219 122.235 64.7219C123.904 64.7219 125.355 65.2994 126.526 66.4906C127.688 67.6736 128.26 69.1179 128.26 70.7746V78.5399H126.112V70.7746C126.112 69.6744 125.726 68.7469 124.969 67.9501C124.219 67.1614 123.324 66.7613 122.235 66.7613C121.111 66.7613 120.176 67.1894 119.376 67.9676C118.579 68.7411 118.141 69.6558 118.141 70.7746V78.5399H115.992V65.0218H118.141V66.1896ZM25.2502 71.8071C25.2502 73.1896 25.7612 74.3388 26.7354 75.3141C27.7142 76.2918 28.8692 76.7993 30.2552 76.7993C31.6284 76.7993 32.7706 76.3011 33.7284 75.3199C34.6909 74.3341 35.1797 73.1733 35.1797 71.7943C35.1797 70.4094 34.6816 69.2451 33.7156 68.2546C32.7566 67.2723 31.6167 66.7613 30.2412 66.7613C28.8552 66.7613 27.7084 67.2851 26.7389 68.2709C25.7671 69.2591 25.2502 70.4188 25.2502 71.8071ZM35.1249 76.8366C34.7364 77.2251 34.2942 77.5634 33.803 77.8528C32.6982 78.5049 31.4977 78.8398 30.2144 78.8398C28.2625 78.8398 26.579 78.1374 25.1942 76.7631C23.8152 75.3946 23.1012 73.7251 23.1012 71.7803C23.1012 69.8354 23.8152 68.1671 25.1942 66.7986C26.579 65.4231 28.2625 64.7219 30.2144 64.7219C31.5199 64.7219 32.7414 65.0789 33.8672 65.7334C34.3327 66.0029 34.755 66.3168 35.1249 66.6773V65.0218H37.2727V78.5399H35.1249V76.8366ZM67.1837 71.8071C67.1837 73.1896 67.6947 74.3388 68.67 75.3141C69.6477 76.2918 70.8039 76.7993 72.1899 76.7993C73.563 76.7993 74.7052 76.3011 75.663 75.3199C76.6244 74.3341 77.1132 73.1733 77.1132 71.7943C77.1132 70.4094 76.615 69.2451 75.649 68.2546C74.69 67.2723 73.5514 66.7613 72.1759 66.7613C70.7899 66.7613 69.643 67.2851 68.6735 68.2709C67.7017 69.2591 67.1837 70.4188 67.1837 71.8071ZM77.0595 76.8366C76.6699 77.2251 76.2289 77.5634 75.7377 77.8528C74.6317 78.5049 73.4312 78.8398 72.149 78.8398C70.1972 78.8398 68.5137 78.1374 67.1289 76.7631C65.7499 75.3946 65.0359 73.7251 65.0359 71.7803C65.0359 69.8354 65.7499 68.1671 67.1289 66.7986C68.5137 65.4231 70.1972 64.7219 72.149 64.7219C73.4545 64.7219 74.676 65.0789 75.8019 65.7334C76.2662 66.0029 76.6885 66.3168 77.0595 66.6773V65.0218H79.2074V78.5399H77.0595V76.8366ZM103.2 75.9803C103.923 76.4621 104.75 76.8273 105.62 76.8273C106.542 76.8273 107.422 76.6289 108.224 76.1646C109.004 75.7131 109.645 75.1099 110.149 74.3609L111.318 72.6273V76.3524L111.151 76.5356C109.773 78.0499 108.053 78.8666 106 78.8666H105.755C103.811 78.8666 102.159 78.1118 100.798 76.7316C99.442 75.3549 98.6965 73.6971 98.6965 71.7534C98.6965 69.8261 99.4245 68.1799 100.79 66.8254C102.207 65.4173 103.951 64.7488 105.945 64.7488C108.064 64.7488 109.822 65.6249 111.235 67.1906L111.644 67.6444L103.2 75.9803V75.9803Z"
        fill="#2FC4CA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.087 84.0466C72.464 84.0466 71.9577 84.5517 71.9577 85.1759C71.9577 85.8001 72.464 86.3052 73.087 86.3052C73.7112 86.3052 74.2176 85.8001 74.2176 85.1759C74.2176 84.5517 73.7112 84.0466 73.087 84.0466ZM4.85338 84.8306L3.50705 87.1371H2.96572L1.61938 84.8446V87.7122H0.612549V82.6396H1.43738L3.24455 85.7242L5.03421 82.6396H5.86021V87.7122H4.85338V84.8306ZM10.8162 87.7507C10.3402 87.7507 9.88405 87.6469 9.46522 87.4159C9.06388 87.1954 8.74072 86.8874 8.50855 86.4907C8.27172 86.0871 8.16322 85.6426 8.16322 85.1759C8.16322 84.7081 8.27172 84.2636 8.50855 83.8611C8.74072 83.4644 9.06388 83.1564 9.46522 82.9347C9.88405 82.7049 10.3402 82.6011 10.8162 82.6011C11.2899 82.6011 11.7449 82.7026 12.1602 82.9324C12.5615 83.1529 12.8824 83.4621 13.1145 83.8576C13.3525 84.2612 13.4622 84.7069 13.4622 85.1759C13.4622 85.6449 13.3525 86.0894 13.1145 86.4942C12.8824 86.8897 12.5615 87.1989 12.1602 87.4194C11.7449 87.6481 11.2899 87.7507 10.8162 87.7507ZM16.5807 83.6009H14.9905V82.6396H19.1964V83.6009H17.6062V87.7122H16.5807V83.6009ZM24.5001 85.6239H22.2169V87.7122H21.1902V82.6396H22.2169V84.6556H24.5001V82.6396H25.5197V87.7122H24.5001V85.6239ZM29.2496 83.6009V84.6626H31.5899V85.6181H29.2496V86.7509H31.9714V87.7122H28.2241V82.6396H31.8745V83.6009H29.2496ZM36.5237 86.2702C36.4479 86.2749 36.3709 86.2772 36.2939 86.2772H35.3524V87.7122H34.3269V82.6396H36.2939C36.8434 82.6396 37.3987 82.7562 37.828 83.1179C38.2387 83.4632 38.4172 83.9322 38.4172 84.4642C38.4172 84.8469 38.3239 85.2109 38.0952 85.5224C37.9424 85.7301 37.7499 85.8887 37.5294 86.0054L38.745 87.7122H37.5492L36.5237 86.2702ZM44.0884 85.6239H41.8052V87.7122H40.7786V82.6396H41.8052V84.6556H44.0884V82.6396H45.1081V87.7122H44.0884V85.6239ZM50.064 87.7507C49.588 87.7507 49.1319 87.6469 48.7142 87.4159C48.3117 87.1954 47.9885 86.8874 47.7564 86.4907C47.5195 86.0871 47.4122 85.6426 47.4122 85.1759C47.4122 84.7081 47.5195 84.2636 47.7564 83.8611C47.9885 83.4644 48.3117 83.1564 48.7142 82.9347C49.1319 82.7049 49.588 82.6011 50.064 82.6011C50.5377 82.6011 50.9927 82.7026 51.4092 82.9324C51.8094 83.1529 52.1302 83.4621 52.3624 83.8576C52.6004 84.2612 52.7112 84.7069 52.7112 85.1759C52.7112 85.6449 52.6004 86.0894 52.3624 86.4942C52.1302 86.8897 51.8094 87.1989 51.4092 87.4194C50.9927 87.6481 50.5377 87.7507 50.064 87.7507ZM57.2659 87.7507C56.7899 87.7507 56.3337 87.6469 55.916 87.4159C55.5135 87.1954 55.1904 86.8874 54.9582 86.4907C54.7214 86.0871 54.614 85.6426 54.614 85.1759C54.614 84.7081 54.7214 84.2636 54.9582 83.8611C55.1904 83.4644 55.5135 83.1564 55.916 82.9347C56.3337 82.7049 56.7899 82.6011 57.2659 82.6011C57.7395 82.6011 58.1945 82.7026 58.611 82.9324C59.0112 83.1529 59.332 83.4621 59.5642 83.8576C59.8022 84.2612 59.913 84.7069 59.913 85.1759C59.913 85.6449 59.8022 86.0894 59.5642 86.4942C59.332 86.8897 59.0112 87.1989 58.611 87.4194C58.1945 87.6481 57.7395 87.7507 57.2659 87.7507ZM62.2161 82.6396H64.3324C64.8177 82.6396 65.2937 82.7317 65.7266 82.9581C66.1302 83.1692 66.4557 83.4702 66.6879 83.8634C66.9259 84.2647 67.0309 84.7104 67.0309 85.1759C67.0309 85.6414 66.9259 86.0871 66.6879 86.4884C66.4557 86.8816 66.1302 87.1814 65.7266 87.3937C65.2937 87.6201 64.8177 87.7122 64.3324 87.7122H62.2161V82.6396ZM82.8801 84.4211L81.7437 87.7122H80.8547L79.1444 82.6396H80.2142L81.3272 85.9564L82.4787 82.6396H83.3164L84.4504 85.9727L85.5797 82.6396H86.6169L84.9065 87.7122H84.0106L82.8801 84.4211ZM89.6385 83.6009V84.6626H91.9789V85.6181H89.6385V86.7509H92.3604V87.7122H88.613V82.6396H92.2635V83.6009H89.6385ZM95.7414 86.7509H98.2754V87.7122H94.7159V82.6396H95.7414V86.7509ZM101.327 86.7509H103.861V87.7122H100.302V82.6396H101.327V86.7509ZM106.913 84.5529V87.7122H105.887V82.6396H106.688L109.197 85.8001V82.6396H110.216V87.7122H109.416L106.913 84.5529ZM113.947 83.6009V84.6626H116.288V85.6181H113.947V86.7509H116.668V87.7122H112.921V82.6396H116.571V83.6009H113.947ZM120.546 87.7507C120.184 87.7507 119.83 87.6936 119.489 87.5734C119.186 87.4684 118.889 87.3121 118.666 87.0776L118.532 86.9376L118.979 86.0602L119.246 86.3262C119.399 86.4802 119.599 86.5864 119.8 86.6611C120.041 86.7509 120.289 86.7952 120.546 86.7952C120.778 86.7952 121.1 86.7684 121.295 86.6261C121.42 86.5339 121.486 86.4254 121.486 86.2679C121.486 86.1792 121.469 86.0941 121.403 86.0311C121.317 85.9447 121.212 85.8852 121.098 85.8432C120.894 85.7697 120.671 85.7137 120.46 85.6612C120.175 85.5901 119.884 85.5084 119.611 85.4011C119.368 85.3054 119.159 85.1584 118.986 84.9624C118.777 84.7256 118.7 84.4246 118.7 84.1154C118.7 83.8377 118.775 83.5776 118.925 83.3431C119.088 83.0911 119.328 82.9137 119.6 82.7924C119.923 82.6477 120.29 82.6011 120.643 82.6011C120.926 82.6011 121.205 82.6396 121.477 82.7177C121.734 82.7912 121.981 82.8974 122.2 83.0502L122.385 83.1762L122.008 84.0664L121.732 83.8856C121.568 83.7771 121.389 83.6931 121.199 83.6382C121.018 83.5857 120.832 83.5554 120.643 83.5554C120.413 83.5554 120.104 83.5834 119.914 83.7292C119.785 83.8261 119.72 83.9416 119.72 84.1026C119.72 84.1936 119.739 84.2799 119.805 84.3452C119.893 84.4327 120 84.4922 120.115 84.5331C120.324 84.6054 120.545 84.6626 120.759 84.7162C121.041 84.7851 121.329 84.8644 121.598 84.9694C121.841 85.0639 122.052 85.2097 122.225 85.4057C122.431 85.6391 122.506 85.9366 122.506 86.2422C122.506 86.5222 122.43 86.7824 122.277 87.0157C122.112 87.2701 121.867 87.4451 121.591 87.5641C121.265 87.7052 120.898 87.7507 120.546 87.7507ZM126.299 87.7507C125.938 87.7507 125.584 87.6936 125.243 87.5734C124.94 87.4684 124.643 87.3121 124.42 87.0776L124.286 86.9376L124.733 86.0602L125 86.3262C125.153 86.4802 125.353 86.5864 125.554 86.6611C125.795 86.7509 126.043 86.7952 126.299 86.7952C126.532 86.7952 126.854 86.7684 127.049 86.6261C127.174 86.5339 127.24 86.4254 127.24 86.2679C127.24 86.1792 127.223 86.0941 127.157 86.0311C127.071 85.9447 126.966 85.8852 126.852 85.8432C126.648 85.7697 126.425 85.7137 126.214 85.6612C125.929 85.5901 125.638 85.5084 125.364 85.4011C125.122 85.3054 124.912 85.1584 124.739 84.9624C124.531 84.7256 124.454 84.4246 124.454 84.1154C124.454 83.8377 124.529 83.5776 124.679 83.3431C124.842 83.0911 125.082 82.9137 125.354 82.7924C125.677 82.6477 126.043 82.6011 126.397 82.6011C126.679 82.6011 126.959 82.6396 127.231 82.7177C127.488 82.7912 127.735 82.8974 127.954 83.0502L128.139 83.1762L127.761 84.0664L127.486 83.8856C127.321 83.7771 127.143 83.6931 126.953 83.6382C126.772 83.5857 126.585 83.5554 126.397 83.5554C126.166 83.5554 125.857 83.5834 125.668 83.7292C125.539 83.8261 125.474 83.9416 125.474 84.1026C125.474 84.1936 125.493 84.2799 125.559 84.3452C125.645 84.4327 125.754 84.4922 125.869 84.5331C126.078 84.6054 126.299 84.6626 126.513 84.7162C126.795 84.7851 127.083 84.8644 127.352 84.9694C127.595 85.0639 127.806 85.2097 127.979 85.4057C128.184 85.6391 128.26 85.9366 128.26 86.2422C128.26 86.5222 128.184 86.7824 128.031 87.0157C127.864 87.2701 127.621 87.4451 127.345 87.5641C127.019 87.7052 126.652 87.7507 126.299 87.7507ZM10.8162 86.7766C11.1114 86.7766 11.3925 86.7136 11.6515 86.5689C11.8965 86.4324 12.0879 86.2434 12.2267 85.9996C12.3725 85.7452 12.4367 85.4687 12.4367 85.1759C12.4367 84.8831 12.3725 84.6066 12.2267 84.3522C12.0879 84.1084 11.8965 83.9194 11.6515 83.7829C11.3925 83.6371 11.1114 83.5752 10.8162 83.5752C10.5187 83.5752 10.2364 83.6382 9.97622 83.7829C9.73005 83.9206 9.53638 84.1084 9.39522 84.3534C9.24822 84.6066 9.18288 84.8831 9.18288 85.1759C9.18288 85.4687 9.24822 85.7452 9.39522 85.9984C9.53638 86.2422 9.73005 86.4312 9.97622 86.5689C10.2364 86.7136 10.5187 86.7766 10.8162 86.7766ZM35.3524 83.6009V85.3217H36.2811C36.5669 85.3217 36.9064 85.2786 37.1339 85.0884C37.3264 84.9274 37.3905 84.7092 37.3905 84.4642C37.3905 84.2181 37.3287 83.9929 37.135 83.8319C36.9064 83.6441 36.5657 83.6009 36.2811 83.6009H35.3524ZM50.064 86.7766C50.3604 86.7766 50.6415 86.7136 50.9005 86.5689C51.1455 86.4324 51.3357 86.2434 51.4745 85.9996C51.6204 85.7452 51.6845 85.4687 51.6845 85.1759C51.6845 84.8831 51.6204 84.6066 51.4745 84.3522C51.3357 84.1084 51.1455 83.9194 50.9005 83.7829C50.6415 83.6371 50.3604 83.5752 50.064 83.5752C49.7665 83.5752 49.4842 83.6382 49.224 83.7829C48.9779 83.9206 48.7854 84.1084 48.643 84.3534C48.496 84.6066 48.4319 84.8831 48.4319 85.1759C48.4319 85.4687 48.496 85.7452 48.643 85.9984C48.7854 86.2422 48.9779 86.4312 49.224 86.5689C49.4842 86.7136 49.7665 86.7766 50.064 86.7766ZM57.2659 86.7766C57.5622 86.7766 57.8434 86.7136 58.1024 86.5689C58.3474 86.4324 58.5375 86.2434 58.6764 85.9996C58.8222 85.7452 58.8864 85.4687 58.8864 85.1759C58.8864 84.8831 58.8222 84.6066 58.6764 84.3522C58.5375 84.1084 58.3474 83.9194 58.1024 83.7829C57.8434 83.6371 57.5622 83.5752 57.2659 83.5752C56.9684 83.5752 56.686 83.6382 56.4259 83.7829C56.1797 83.9206 55.9872 84.1084 55.8449 84.3534C55.6979 84.6066 55.6337 84.8831 55.6337 85.1759C55.6337 85.4687 55.6979 85.7452 55.8449 85.9984C55.9872 86.2422 56.1797 86.4312 56.4259 86.5689C56.686 86.7136 56.9684 86.7766 57.2659 86.7766ZM63.2416 83.6009V86.7509H64.3067C64.6229 86.7509 64.9379 86.6949 65.219 86.5467C65.4652 86.4161 65.6612 86.2364 65.8024 85.9972C65.9505 85.7452 66.01 85.4664 66.01 85.1759C66.01 84.8854 65.9505 84.6066 65.8024 84.3546C65.6612 84.1154 65.4652 83.9346 65.219 83.8051C64.9379 83.6557 64.6229 83.6009 64.3067 83.6009H63.2416V83.6009Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.2286 43.3744C59.4185 39.2059 59.968 36.2799 59.7416 31.486C59.6098 28.6802 58.9705 24.0649 57.4235 21.7047C56.713 20.622 55.6035 19.3539 54.4205 18.788C53.703 18.445 52.9446 18.3272 52.1851 18.6247C51.3428 18.956 50.847 19.656 50.5518 20.4855C48.9383 25.0134 52.6868 32.3657 49.2801 36.547C48.2068 37.87 46.5245 38.808 44.8701 39.1662C42.7841 39.6224 40.7646 39.2 39.2305 37.7639C40.1895 39.6737 42.4108 40.7855 44.4595 41.0434C47.1311 41.3794 49.7188 40.3854 51.4245 38.29C55.4996 33.2897 52.2481 27.7317 52.968 22.2647C52.9995 22.0197 53.1616 21.8237 53.3961 21.7432C53.6306 21.665 53.8756 21.721 54.0506 21.8949C54.4496 22.2915 54.7961 22.7512 55.103 23.2202C56.3956 25.1919 56.8716 29.2635 56.9825 31.6132C57.1003 34.1437 56.9766 37.5749 55.8695 39.8802C55.5323 40.5884 55.2033 41.2604 54.8556 41.9172C53.1161 41.1204 51.7348 40.9209 49.8296 41.2184C48.9406 41.3572 48.0563 41.6092 47.1743 41.9382C44.5785 42.9054 41.9126 44.8187 41.3853 47.7144C41.0948 49.2952 41.5335 50.9017 42.7316 52.003C44.0395 53.2059 45.779 53.431 47.4601 53.0192C51.1176 52.1197 53.6843 48.685 55.7785 45.7567C57.6895 47.1812 60.2725 49.742 62.0645 51.4547C59.2341 53.1335 57.3348 53.6165 54.3761 54.3189C57.7326 54.5405 61.3155 54.3469 64.4293 53.0309C67.5431 54.3469 71.1271 54.5405 74.4825 54.3189C71.525 53.6165 69.6256 53.1335 66.7953 51.4547C68.5861 49.742 71.1703 47.1812 73.0813 45.7567C75.1743 48.685 77.741 52.1197 81.3996 53.0192C83.0808 53.431 84.8191 53.2059 86.127 52.003C87.3263 50.9017 87.7638 49.2952 87.4745 47.7144C86.946 44.8187 84.2801 42.9054 81.6843 41.9382C80.8035 41.6092 79.918 41.3572 79.0301 41.2184H79.029C77.125 40.9209 75.7425 41.1204 74.003 41.9172C73.6553 41.2604 73.3275 40.5884 72.9903 39.8802C71.882 37.5749 71.7583 34.1437 71.8761 31.6132C71.9881 29.2635 72.4641 25.1919 73.7556 23.2202C74.0636 22.7512 74.409 22.2915 74.808 21.8949C74.983 21.721 75.2291 21.665 75.4636 21.7432C75.6981 21.8237 75.8591 22.0197 75.8918 22.2647C76.6105 27.7317 73.359 33.2897 77.4341 38.29C79.1398 40.3854 81.7275 41.3794 84.4003 41.0434C86.4478 40.7855 88.6691 39.6737 89.6293 37.7639C88.0951 39.2 86.0745 39.6224 83.9885 39.1662C82.3341 38.808 80.653 37.87 79.5785 36.547C76.1718 32.3657 79.9215 25.0134 78.3068 20.4855C78.0116 19.656 77.5158 18.956 76.6735 18.6247C75.914 18.3272 75.1568 18.445 74.4381 18.788C73.2563 19.3539 72.1456 20.622 71.4363 21.7047C69.8893 24.0649 69.2488 28.6802 69.117 31.486C68.8918 36.2799 69.4401 39.2059 71.63 43.3744C69.2465 44.9937 66.5223 47.6887 64.4293 49.6895C62.3363 47.6887 59.6133 44.9937 57.2286 43.3744ZM75.4741 44.3975C76.9115 46.5524 79.2798 49.6499 82.06 50.3335C82.7775 50.5097 83.6816 50.4957 84.2556 49.9672C84.7398 49.5215 84.8728 48.8402 84.7573 48.2125C84.1308 44.7814 78.364 43.2974 75.4741 44.3975ZM53.3856 44.3975C51.9471 46.5524 49.58 49.6499 46.7986 50.3335C46.0823 50.5097 45.177 50.4957 44.603 49.9672C44.12 49.5215 43.9858 48.8402 44.1013 48.2125C44.729 44.7814 50.4946 43.2974 53.3856 44.3975V44.3975Z"
        fill="#37C1C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.6077 14.9076C43.9472 15.176 44.3042 15.4221 44.6763 15.6415C45.724 16.2563 46.8848 16.6553 48.0877 16.8163C50.4735 17.136 52.9025 16.4908 54.817 15.0301C56.7432 13.5566 57.9915 11.3971 58.3123 8.9938C58.5305 7.37797 59.3752 5.92897 60.6713 4.93964C61.9617 3.9538 63.6055 3.51747 65.2178 3.73214C66.8325 3.94914 68.2827 4.79497 69.272 6.09114C70.2578 7.38147 70.6953 9.02413 70.4795 10.6365C69.8448 15.3778 65.4617 17.1173 61.1952 16.4943C61.9092 17.3098 63.0852 17.8406 64.1083 18.067C66.0683 18.5033 68.1917 18.116 69.7993 16.8875C71.6835 15.449 72.9027 13.3385 73.2165 10.9876C73.5292 8.65547 72.898 6.28247 71.4688 4.4123C70.0303 2.52814 67.9187 1.3078 65.569 0.993969C63.2368 0.681302 60.8627 1.3113 58.9937 2.74164C57.1072 4.1813 55.8892 6.2918 55.5742 8.64147C54.8088 14.3698 48.4563 15.8433 43.6077 14.9076"
        fill="#37C1C4"
      />
      <mask
        id="mask0_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="58"
        y="0"
        width="16"
        height="19"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.6715 4.94082C61.9618 3.95382 63.6057 3.51749 65.218 3.73215C66.8327 3.94915 68.2828 4.79499 69.271 6.09115C70.258 7.38149 70.6955 9.02415 70.4785 10.6365C69.845 15.379 65.4618 17.1173 61.1953 16.4932C61.9093 17.3098 63.0853 17.8407 64.1073 18.067C66.0685 18.5033 68.1918 18.116 69.7995 16.8875C71.6837 15.449 72.9028 13.3385 73.2167 10.9877C73.5293 8.65665 72.897 6.28249 71.469 4.41232C70.0305 2.52815 67.9188 1.30782 65.5692 0.993985C65.0967 0.930985 64.623 0.906485 64.1528 0.919318C59.9972 1.06165 58.3125 6.12499 58.3125 8.99382C58.5295 7.37799 59.3753 5.92782 60.6715 4.94082"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.6715 4.94082C61.9618 3.95382 63.6057 3.51749 65.218 3.73215C66.8327 3.94915 68.2828 4.79499 69.271 6.09115C70.258 7.38149 70.6955 9.02415 70.4785 10.6365C69.845 15.379 65.4618 17.1173 61.1953 16.4932C61.9093 17.3098 63.0853 17.8407 64.1073 18.067C66.0685 18.5033 68.1918 18.116 69.7995 16.8875C71.6837 15.449 72.9028 13.3385 73.2167 10.9877C73.5293 8.65665 72.897 6.28249 71.469 4.41232C70.0305 2.52815 67.9188 1.30782 65.5692 0.993985C65.0967 0.930985 64.623 0.906485 64.1528 0.919318C59.9972 1.06165 58.3125 6.12499 58.3125 8.99382C58.5295 7.37799 59.3753 5.92782 60.6715 4.94082"
          fill="url(#paint0_linear_35_4318)"
        />
      </g>
      <mask
        id="mask1_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="59"
        y="47"
        width="6"
        height="5"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.1243 48.6453C60.1778 49.6311 61.2114 50.6391 62.0643 51.4546C63.1248 50.8258 63.6591 50.3976 64.4291 49.6895C63.6019 48.8985 62.6768 48.0001 61.7119 47.1018C60.7891 47.5556 59.7729 48.1133 59.1243 48.6453"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.1243 48.6453C60.1778 49.6311 61.2114 50.6391 62.0643 51.4546C63.1248 50.8258 63.6591 50.3976 64.4291 49.6895C63.6019 48.8985 62.6768 48.0001 61.7119 47.1018C60.7891 47.5556 59.7729 48.1133 59.1243 48.6453"
          fill="url(#paint1_linear_35_4318)"
        />
      </g>
      <mask
        id="mask2_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="64"
        y="51"
        width="11"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.4292 53.0308C67.543 54.3468 71.127 54.5404 74.4824 54.3188C71.5249 53.6164 69.6255 53.1334 66.7952 51.4546C66.2679 51.9598 65.3205 52.6948 64.4292 53.0308"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.4292 53.0308C67.543 54.3468 71.127 54.5404 74.4824 54.3188C71.5249 53.6164 69.6255 53.1334 66.7952 51.4546C66.2679 51.9598 65.3205 52.6948 64.4292 53.0308"
          fill="url(#paint2_linear_35_4318)"
        />
      </g>
      <mask
        id="mask3_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="53"
        y="20"
        width="7"
        height="7"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.1029 23.2201C55.6851 24.1091 56.1016 25.424 56.3944 26.8146L59.1338 26.5276C58.8059 24.9036 58.3358 23.317 57.6848 22.141C56.0456 19.999 53.9922 20.3221 53.0764 21.9811C53.1522 21.8726 53.2619 21.7886 53.3961 21.7431C53.6306 21.665 53.8756 21.721 54.0506 21.8948C54.4496 22.2915 54.7961 22.7511 55.1029 23.2201"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.1029 23.2201C55.6851 24.1091 56.1016 25.424 56.3944 26.8146L59.1338 26.5276C58.8059 24.9036 58.3358 23.317 57.6848 22.141C56.0456 19.999 53.9922 20.3221 53.0764 21.9811C53.1522 21.8726 53.2619 21.7886 53.3961 21.7431C53.6306 21.665 53.8756 21.721 54.0506 21.8948C54.4496 22.2915 54.7961 22.7511 55.1029 23.2201"
          fill="url(#paint3_linear_35_4318)"
        />
      </g>
      <mask
        id="mask4_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="69"
        y="20"
        width="7"
        height="7"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.7555 23.2201C73.1733 24.1091 72.7568 25.424 72.4652 26.8146L69.7258 26.5276C70.0525 24.9036 70.5238 23.317 71.1737 22.141C72.8128 19.999 74.8673 20.3221 75.7832 21.9811C75.7073 21.8726 75.5965 21.7886 75.4635 21.7431C75.229 21.665 74.9828 21.721 74.8078 21.8948C74.4088 22.2915 74.0635 22.7511 73.7555 23.2201"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M73.7555 23.2201C73.1733 24.1091 72.7568 25.424 72.4652 26.8146L69.7258 26.5276C70.0525 24.9036 70.5238 23.317 71.1737 22.141C72.8128 19.999 74.8673 20.3221 75.7832 21.9811C75.7073 21.8726 75.5965 21.7886 75.4635 21.7431C75.229 21.665 74.9828 21.721 74.8078 21.8948C74.4088 22.2915 74.0635 22.7511 73.7555 23.2201"
          fill="url(#paint4_linear_35_4318)"
        />
      </g>
      <mask
        id="mask5_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="54"
        y="36"
        width="6"
        height="8"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.7326 36.9564C56.5553 38.0169 56.28 39.0261 55.8693 39.8801C55.5321 40.5883 55.2031 41.2603 54.8555 41.9171C55.6045 42.2438 56.6965 42.9998 57.2285 43.3743C58.4453 41.0584 59.1558 39.1253 59.5081 37.0428C58.6005 36.9541 57.6135 36.9028 56.7326 36.9564"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.7326 36.9564C56.5553 38.0169 56.28 39.0261 55.8693 39.8801C55.5321 40.5883 55.2031 41.2603 54.8555 41.9171C55.6045 42.2438 56.6965 42.9998 57.2285 43.3743C58.4453 41.0584 59.1558 39.1253 59.5081 37.0428C58.6005 36.9541 57.6135 36.9028 56.7326 36.9564"
          fill="url(#paint5_linear_35_4318)"
        />
      </g>
      <mask
        id="mask6_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="48"
        y="44"
        width="8"
        height="7"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.3855 44.3975C52.2795 46.0553 50.6228 48.2708 48.6511 49.5156C49.3301 50.2005 50.372 50.6636 51.3076 50.967C53.0635 49.497 54.5078 47.5335 55.7783 45.7566C55.2836 45.3751 54.1391 44.66 53.3855 44.3975"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.3855 44.3975C52.2795 46.0553 50.6228 48.2708 48.6511 49.5156C49.3301 50.2005 50.372 50.6636 51.3076 50.967C53.0635 49.497 54.5078 47.5335 55.7783 45.7566C55.2836 45.3751 54.1391 44.66 53.3855 44.3975"
          fill="url(#paint6_linear_35_4318)"
        />
      </g>
      <mask
        id="mask7_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="69"
        y="36"
        width="6"
        height="8"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.1257 36.9564C72.3042 38.0169 72.5795 39.0261 72.9902 39.8801C73.3273 40.5883 73.6552 41.2603 74.0028 41.9171C73.255 42.2438 72.1618 42.9998 71.6298 43.3743C70.413 41.0584 69.7037 39.1253 69.3513 37.0428C70.2578 36.9541 71.246 36.9028 72.1257 36.9564"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.1257 36.9564C72.3042 38.0169 72.5795 39.0261 72.9902 39.8801C73.3273 40.5883 73.6552 41.2603 74.0028 41.9171C73.255 42.2438 72.1618 42.9998 71.6298 43.3743C70.413 41.0584 69.7037 39.1253 69.3513 37.0428C70.2578 36.9541 71.246 36.9028 72.1257 36.9564"
          fill="url(#paint7_linear_35_4318)"
        />
      </g>
      <mask
        id="mask8_35_4318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="73"
        y="44"
        width="8"
        height="7"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.4741 44.3975C76.5801 46.0553 78.2368 48.2708 80.2073 49.5156C79.5283 50.2005 78.4865 50.6636 77.552 50.967C75.795 49.497 74.3506 47.5335 73.0813 45.7566C73.576 45.3751 74.7193 44.66 75.4741 44.3975"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_35_4318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.4741 44.3975C76.5801 46.0553 78.2368 48.2708 80.2073 49.5156C79.5283 50.2005 78.4865 50.6636 77.552 50.967C75.795 49.497 74.3506 47.5335 73.0813 45.7566C73.576 45.3751 74.7193 44.66 75.4741 44.3975"
          fill="url(#paint8_linear_35_4318)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_35_4318"
          x1="68.9907"
          y1="3.00949"
          x2="60.2146"
          y2="-3.33166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_4318"
          x1="59.8207"
          y1="50.1166"
          x2="61.9675"
          y2="53.3827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_35_4318"
          x1="72.6047"
          y1="52.8625"
          x2="72.2666"
          y2="49.8162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_35_4318"
          x1="60.4962"
          y1="22.7213"
          x2="57.1468"
          y2="16.5069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_35_4318"
          x1="74.5078"
          y1="26.0342"
          x2="77.8584"
          y2="19.8199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_35_4318"
          x1="55.9408"
          y1="37.9753"
          x2="52.3437"
          y2="41.1135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_35_4318"
          x1="54.6656"
          y1="48.5896"
          x2="57.2681"
          y2="44.7918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_35_4318"
          x1="69.8059"
          y1="41.5427"
          x2="73.4035"
          y2="44.6799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_35_4318"
          x1="78.0921"
          y1="45.9171"
          x2="75.489"
          y2="42.1197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C3" />
          <stop offset="1" stopColor="#4D4D4D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <rect opacity="0.01" width="24" height="24" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7301 5.00012C17.7101 4.82012 21.2301 10.3901 21.8701 11.5001C22.0487 11.8095 22.0487 12.1907 21.8701 12.5001C21.0101 14.0001 17.8001 18.8601 12.2701 19.0001H12.0201C6.13007 19.0001 2.76007 13.5901 2.13007 12.5001C1.95144 12.1907 1.95144 11.8095 2.13007 11.5001C3.00007 10.0001 6.20007 5.14012 11.7301 5.00012ZM4.22007 12.0001C5.10007 13.4101 7.91007 17.1001 12.2201 17.0001C16.2201 16.9001 18.8001 13.6101 19.8301 12.0001C18.9401 10.5901 16.1201 6.89012 11.8301 7.00012C7.83007 7.10012 5.22007 10.3901 4.22007 12.0001Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12Z"
        fill="black"
      />
    </svg>
  );
};

export const LockIcon = (props) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#37C1C4" />
      <path
        d="M19.2492 13.2719H11V10.3625C11 8.75625 12.3437 7.45312 14 7.45312C15.6563 7.45312 17 8.75625 17 10.3625V11.0906H18.4984V10.3625C18.4984 7.95313 16.4844 6 14 6C11.5156 6 9.50161 7.95313 9.50161 10.3625V13.2719H8.75081C8.33835 13.2719 8 13.5969 8 14V21.2719C8 21.675 8.33512 22 8.75081 22H19.2492C19.6617 22 20 21.675 20 21.2719V14C20 13.5969 19.6649 13.2719 19.2492 13.2719Z"
        fill="white"
      />
    </svg>
  );
};
export const BellIcon = (props) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#37C1C4" />
      <path
        d="M14.0588 22C14.5445 22.0006 15.0184 21.8469 15.4145 21.5601C15.8106 21.2734 16.1093 20.8679 16.269 20.4H11.8486C12.0084 20.8679 12.307 21.2734 12.7031 21.5601C13.0992 21.8469 13.5731 22.0006 14.0588 22ZM19.549 16.0688V12.4C19.549 9.8264 17.8353 7.6584 15.5137 7.0064C15.2839 6.416 14.7224 6 14.0588 6C13.3953 6 12.8337 6.416 12.6039 7.0064C10.2824 7.6592 8.56863 9.8264 8.56863 12.4V16.0688L7.2298 17.4344C7.15683 17.5086 7.09896 17.5967 7.05952 17.6938C7.02008 17.7909 6.99985 17.8949 7 18V18.8C7 19.0122 7.08263 19.2157 7.22972 19.3657C7.37681 19.5157 7.5763 19.6 7.78431 19.6H20.3333C20.5413 19.6 20.7408 19.5157 20.8879 19.3657C21.035 19.2157 21.1176 19.0122 21.1176 18.8V18C21.1178 17.8949 21.0976 17.7909 21.0581 17.6938C21.0187 17.5967 20.9608 17.5086 20.8878 17.4344L19.549 16.0688Z"
        fill="white"
      />
    </svg>
  );
};
export const StarIcon = (props) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#37C1C4" />
      <path
        d="M22.2133 11.6341L17.1905 10.9041L14.9452 6.35214C14.8839 6.22751 14.783 6.12662 14.6584 6.06529C14.3458 5.91099 13.966 6.03957 13.8097 6.35214L11.5644 10.9041L6.54161 11.6341C6.40314 11.6538 6.27653 11.7191 6.17959 11.818C6.06241 11.9385 5.99783 12.1005 6.00006 12.2686C6.00228 12.4366 6.07113 12.5969 6.19146 12.7142L9.8255 16.2572L8.96694 21.2602C8.94681 21.3766 8.95969 21.4963 9.00412 21.6057C9.04855 21.7151 9.12275 21.8099 9.21832 21.8793C9.31388 21.9488 9.42698 21.99 9.54479 21.9984C9.6626 22.0068 9.78041 21.982 9.88485 21.9269L14.3774 19.5648L18.87 21.9269C18.9927 21.9922 19.1351 22.0139 19.2716 21.9902C19.6158 21.9308 19.8473 21.6044 19.788 21.2602L18.9294 16.2572L22.5634 12.7142C22.6623 12.6172 22.7276 12.4906 22.7474 12.3522C22.8008 12.006 22.5595 11.6855 22.2133 11.6341Z"
        fill="white"
      />
    </svg>
  );
};
export const FiveStar = (props) => {
  return (
    <svg
      {...props}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.45245 4.78223L6.68728 0.489868L8.98039 4.78223L13.4984 5.63502L10.2717 9.06273L10.8898 13.94L6.68728 11.8561L2.59803 13.94L3.30354 9.06273L0.0831299 5.63502L4.45245 4.78223Z"
        fill="#FFC107"
      />
    </svg>
  );
};

export const BlueTickIcon = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10.197" r="10" fill="#37C1C4" />
      <g clipPath="url(#clip0_301_53)">
        <path
          d="M4 10.5799L8.10933 14.6971L16 6.81419L14.8672 5.69702L8.10933 12.447L5.11715 9.45486L4 10.5799Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_301_53">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(4 4.19702)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.01" width="24" height="24" fill="white" />
      <path
        d="M14.31 16.38L13 17.64V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V17.59L9.71003 16.29C9.45637 16.0363 9.08665 15.9373 8.74015 16.0301C8.39364 16.123 8.12299 16.3936 8.03015 16.7401C7.9373 17.0866 8.03637 17.4563 8.29003 17.71L11.29 20.71C11.4787 20.8972 11.7342 21.0015 12 21C12.2575 20.999 12.5046 20.8987 12.69 20.72L15.69 17.82C15.9793 17.5813 16.1107 17.2009 16.0304 16.8346C15.9501 16.4683 15.6716 16.1777 15.309 16.0819C14.9465 15.9861 14.5608 16.1012 14.31 16.38V16.38Z"
        fill="white"
      />
      <path
        d="M17.67 6.99998C16.8336 4.58332 14.5573 2.9624 12 2.9624C9.44267 2.9624 7.16641 4.58332 6.32998 6.99998C4.49924 7.24518 2.95281 8.47973 2.30815 10.2107C1.66349 11.9416 2.02564 13.887 3.24998 15.27C3.44846 15.6196 3.83697 15.8163 4.23623 15.7695C4.63549 15.7226 4.96787 15.4412 5.07995 15.0551C5.19204 14.669 5.06206 14.2534 4.74998 14C3.95958 13.1163 3.76373 11.85 4.25026 10.7689C4.73678 9.68769 5.8144 8.99446 6.99998 8.99998H7.09998C7.58274 9.00972 8.00351 8.6731 8.09998 8.19998C8.47854 6.33572 10.1177 4.99597 12.02 4.99597C13.9223 4.99597 15.5614 6.33572 15.94 8.19998C16.0365 8.6731 16.4572 9.00972 16.94 8.99998H17C18.1856 8.99446 19.2632 9.68769 19.7497 10.7689C20.2362 11.85 20.0404 13.1163 19.25 14C19.0721 14.1995 18.9814 14.462 18.9983 14.7288C19.0153 14.9956 19.1383 15.2445 19.34 15.42C19.5223 15.5808 19.7569 15.6696 20 15.67C20.2872 15.6696 20.5604 15.5458 20.75 15.33C22.0088 13.9487 22.3923 11.9808 21.7442 10.228C21.0961 8.47511 19.5246 7.23002 17.67 6.99998Z"
        fill="white"
      />
    </svg>
  );
};
export const NotificationIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.01" width="24" height="24" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.52 15.2102L18.72 13.4002V8.94018C18.7695 5.51552 16.2855 2.57906 12.9 2.06018C10.9778 1.80703 9.0396 2.39394 7.58072 3.67094C6.12184 4.94794 5.28353 6.79135 5.28 8.73018V13.4002L3.48 15.2102C3.01776 15.6801 2.88181 16.3812 3.13487 16.9898C3.38794 17.5985 3.98083 17.9965 4.64 18.0002H8V18.3402C8.09725 20.4539 9.88601 22.0906 12 22.0002C14.114 22.0906 15.9027 20.4539 16 18.3402V18.0002H19.36C20.0192 17.9965 20.6121 17.5985 20.8651 16.9898C21.1182 16.3812 20.9822 15.6801 20.52 15.2102ZM14 18.3402C13.8848 19.3395 13.0034 20.071 12 20.0002C10.9966 20.071 10.1152 19.3395 10 18.3402V18.0002H14V18.3402ZM6.69 14.8202L5.51 16.0002H18.49L17.3 14.8202C16.9256 14.4427 16.7169 13.9318 16.72 13.4002V8.90018C16.7712 6.47828 15.0311 4.38842 12.64 4.00018C11.2821 3.82296 9.91482 4.25068 8.9 5.17018C7.87168 6.06755 7.2811 7.36537 7.27999 8.73018V13.4002C7.28042 13.9332 7.06803 14.4444 6.69 14.8202Z"
        fill="white"
      />
    </svg>
  );
};
export const HeartIcon = (props) => {
  return (
    <svg
      {...props}
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.29 16.71C10.4787 16.8972 10.7342 17.0016 11 17C11.2658 17.0016 11.5213 16.8972 11.71 16.71L19.48 8.93002C21.5084 6.88037 21.5084 3.57966 19.48 1.53002C17.4349 -0.509354 14.1251 -0.509354 12.08 1.53002L11 2.61002L9.91999 1.53002C7.87485 -0.509354 4.56514 -0.509354 2.51999 1.53002C0.491545 3.57966 0.491545 6.88037 2.51999 8.93002L10.29 16.71ZM3.93999 2.94002C4.54388 2.33465 5.36493 1.99615 6.21999 2.00002C7.07506 1.99615 7.89611 2.33465 8.49999 2.94002L10.29 4.74002C10.4778 4.92933 10.7334 5.03582 11 5.03582C11.2666 5.03582 11.5222 4.92933 11.71 4.74002L13.5 2.94002C14.7796 1.73108 16.7804 1.73108 18.06 2.94002C19.3173 4.20392 19.3173 6.24611 18.06 7.51002L11 14.58L3.93999 7.51002C2.68271 6.24611 2.68271 4.20392 3.93999 2.94002Z"
        fill="white"
      />
    </svg>
  );
};
export const ShareIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.01" width="24" height="24" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9 15.8598C16.4604 15.3092 17.2144 15.0004 18 14.9998C19.6569 14.9998 21 16.3429 21 17.9998C21 19.6567 19.6569 20.9998 18 20.9998C16.3432 20.9998 15 19.6567 15 17.9998V17.6698L7.10003 14.1398C5.92307 15.2961 4.03324 15.285 2.86999 14.1149C1.70675 12.9447 1.70675 11.0549 2.86999 9.88474C4.03324 8.71462 5.92307 8.70347 7.10003 9.8598L15 6.3398V5.9998C14.9989 4.57117 16.0053 3.33991 17.4056 3.05685C18.8059 2.77378 20.2116 3.51744 20.7654 4.83435C21.3193 6.15126 20.8676 7.67603 19.6859 8.47886C18.5042 9.2817 16.9203 9.13984 15.9 8.1398L8.00003 11.6698V11.9998V12.3398L15.9 15.8598ZM19 5.9998C19 5.44751 18.5523 4.9998 18 4.9998C17.4477 4.9998 17 5.44751 17 5.9998C17 6.55208 17.4477 6.9998 18 6.9998C18.5523 6.9998 19 6.55208 19 5.9998ZM5.00003 12.9998C4.44775 12.9998 4.00003 12.5521 4.00003 11.9998C4.00003 11.4475 4.44775 10.9998 5.00003 10.9998C5.55232 10.9998 6.00003 11.4475 6.00003 11.9998C6.00003 12.5521 5.55232 12.9998 5.00003 12.9998ZM17 17.9998C17 18.5521 17.4477 18.9998 18 18.9998C18.5523 18.9998 19 18.5521 19 17.9998C19 17.4475 18.5523 16.9998 18 16.9998C17.4477 16.9998 17 17.4475 17 17.9998Z"
        fill="white"
      />
    </svg>
  );
};

export const PlayPauseIcon = (props) => {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props?.play !== "playing" ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.4223 26.2111C40.8964 26.9482 40.8964 29.0518 39.4223 29.7889L21.8944 38.5528C20.5646 39.2177 19 38.2507 19 36.7639L19 19.2361C19 17.7493 20.5646 16.7823 21.8944 17.4472L39.4223 26.2111Z"
          fill="#F4F4F8"
        />
      ) : null}
      <path
        d="M1 16C1 7.71573 7.71573 1 16 1H55V40C55 48.2843 48.2843 55 40 55H16C7.71573 55 1 48.2843 1 40V16Z"
        fill="white"
        fillOpacity="0.2"
        stroke="white"
        strokeWidth="2"
      />
      {props?.play === "playing" ? (
        <>
          <mask
            id="mask0_0_560"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="30"
            y="16"
            width="6"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.339 16.0288C34.7905 16.0288 35.9669 17.2053 35.9669 18.6566V37.3434C35.9669 38.7947 34.7903 39.9712 33.339 39.9712C31.8877 39.9712 30.7112 38.7947 30.7112 37.3434V18.6566C30.7112 17.2053 31.8877 16.0288 33.339 16.0288Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_0_560)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.7112 11.0288H40.9668V44.9712H25.7112V11.0288Z"
              fill="white"
            />
          </g>
          <mask
            id="mask1_0_560"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="20"
            y="16"
            width="6"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.6609 16.0288C24.1124 16.0288 25.2887 17.2053 25.2887 18.6566V37.3434C25.2887 38.7947 24.1122 39.9712 22.6609 39.9712C21.2096 39.9712 20.0331 38.7947 20.0331 37.3434V18.6566C20.0331 17.2053 21.2096 16.0288 22.6609 16.0288Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_0_560)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.0331 11.0288H30.2887V44.9712H15.0331V11.0288Z"
              fill="white"
            />
          </g>
        </>
      ) : null}
    </svg>
  );
};

export const NoteIcon = (props) => {
  return (
    <svg {...props} width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z"
        fill="url(#paint0_linear_5_326)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0818 46.3062C19.79 46.3062 19.5488 46.0694 19.5488 45.773V39.4182H15.1226C13.917 39.4182 12.9364 38.4376 12.9364 37.2322V15.8802C12.9364 14.6748 13.917 13.694 15.1226 13.694H44.8776C46.0832 13.694 47.0638 14.6746 47.0638 15.8802V37.2322C47.0638 38.4376 46.0832 39.4182 44.8776 39.4182H27.8644L20.4406 46.1676C20.3402 46.2584 20.2116 46.3062 20.0818 46.3062ZM30.0002 34.9006C28.7682 34.9006 27.7658 33.8982 27.7658 32.666C27.7658 31.4338 28.7682 30.4316 30.0002 30.4316C31.2324 30.4316 32.2348 31.4336 32.2348 32.666C32.2348 33.8984 31.2326 34.9006 30.0002 34.9006ZM30.0002 29.1932C28.8042 29.1932 27.8286 28.2344 27.7306 26.963L27.1454 19.3712C27.0966 18.7384 27.6362 18.2116 28.2628 18.2116H31.7386C32.3644 18.2116 32.9044 18.7386 32.8556 19.3712L32.2704 26.9626C32.1718 28.2344 31.1962 29.1932 30.0002 29.1932Z"
        fill="#1D374A"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5_326"
          x1="30"
          y1="0"
          x2="30"
          y2="60"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37C1C4" />
          <stop offset="1" stopColor="#37A4C4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
